// src/app/services/property.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { ProjectService } from '../project.service';

@Injectable({
  providedIn: 'root',
})
export class PropertyService {
  private propertyIdSubject = new BehaviorSubject<any>('');
  private apiUrl = '/api/properties';

  constructor(private http: HttpClient,public projectService:ProjectService) {}

  getAll(path: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}${path}`);
  }

  getById(path: string, id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}${path}/${id}`);
  }
 
  create(path: string, data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}${path}`, data);
  }

  update(path: string, id: any, data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}${path}/${id}`, data);
  }

  bulkUpload(path: string, data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}${path}/bulk`, data);
  }

  delete(path: string, id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}${path}/${id}`);
  }

  edit(path: string, data: any): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}${path}`, data);
  }

  updatePropertyId(data): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}`, data);
  }

  post(path,data): Observable<any> {
    return this.http.post<any>(`${this.apiUrl}${path}`, data);
  }

  
  put(path,data): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}${path}`, data);
  }
  
  getMetaDataBySchemaType(schemaType): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/property-data-schema/by-schema-type/${schemaType}`);
  }

  getMetaData(schemaType,projectPropertyId): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/project-property-data-schema/schema/${schemaType}/${projectPropertyId}`);
  }

  getSubjectProperties(projectId) {
    this.projectService.getDetailsByProjectId(projectId).subscribe(res => {
      this.propertyIdSubject.next(res.data.project.properties);
    })
  }
 
  getProjectPropertyId(projectId,propertyId): Observable<any> {
   
    return this.http.get<any>(`${this.apiUrl}/project-property/project-property/${projectId}`);

    // return this.http.get<any>(`${this.apiUrl}/project-property/project/${projectId}/property/${propertyId}`);
  }

  
  putProjectPropertySchema(subjectPropertiesId,tableName,data): Observable<any> {    
    return this.http.put<any>(`${this.apiUrl}/project-property-data-schema/schema/${tableName}/${subjectPropertiesId}`,data);
  }

  updatePropertySchemaData(subjectPropertiesId,tableName,data){
    return this.http.put<any>(`${this.apiUrl}/project-property-data/update-data/${tableName}/${subjectPropertiesId}`,data);
  }

  
  getByName(path: string, name: string): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}${path}/${name}`);
  }

  getCompData(path: string,queryString: any ): Observable<any> {
    const url = `${this.apiUrl}/${path}?${queryString}`;
    return this.http.get<any>(url);
  }
  
  getIncludesFromMetaSchema() {
    return this.http.get<any>(`${this.apiUrl}/property-data-schema/schema/metadata`);
}
}
